import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { cn } from '../lib/utils';

const { FiRefreshCw } = FiIcons;

const RefreshButton = () => {
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    const handleRefreshState = (e) => {
      setRefreshing(e.detail.refreshing);
    };

    window.addEventListener('kanban-refresh-state', handleRefreshState);
    return () => window.removeEventListener('kanban-refresh-state', handleRefreshState);
  }, []);

  const handleRefresh = () => {
    window.dispatchEvent(new Event('kanban-refresh-trigger'));
  };

  return (
    <button
      onClick={handleRefresh}
      disabled={refreshing}
      className="h-11 w-11 shrink-0 flex items-center justify-center bg-zinc-800 hover:bg-zinc-700 text-yellow-400 rounded-md transition-colors disabled:opacity-50 border border-zinc-700"
      title={refreshing ? 'Updating...' : 'Refresh'}
    >
      <SafeIcon
        icon={FiRefreshCw}
        className={cn(
          "text-yellow-400",
          refreshing && "animate-spin"
        )}
        size={20}
      />
    </button>
  );
};

export default RefreshButton;